import type { JobStatus } from '@/api/fe-api/domain/entities/capacity-evaluation';

export function getStatusColor(status: JobStatus) {
  switch (status) {
    case 'Completed':
      return 'green';
    case 'Pending':
      return 'yellow';
    case 'Failed':
      return 'red';
    default:
      return 'zinc';
  }
}
